<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records recommended-questionnaire h-100">
            <div class="row h-100">
                <div class="col-12 mb-4 h-100">
                    <div class="card border-0 h-100">
                        <div class="card-body p-0 h-100">
                            <div class="bg-white border-radius-5 p-4 h-100">
                                <div class="row no-gutters justify-content-center align-items-center h-100">
                                    <div class="col-md-5 text-center submit-question">
                                        <figure class="mb-0"><img src="../../../../static/website/images/test_successfully.png" alt="" /></figure>
                                        <p>Thank you, Answers Submitted Successfully. Doctor will review and get back to you soon.</p>
                                        <router-link to="/intake-questionaries" class="btn btn-blue save">Back To Questionnaire</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "submit-question",
        data() {
            return {};
        },
        created(){
           this.pageName('Intake Questionnaire')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/questionaries/submit-question.vue